import React from "react";

import "./surfaceUi.css";
import "./parity.css";

const classes = (...values) => values.filter(Boolean).join(" ");

export const FilterBar = ({
  title,
  description,
  disabled = false,
  className,
  children,
}) => (
  <fieldset
    className={classes("mis-filter-bar", className)}
    disabled={disabled}
    aria-busy={disabled}
  >
    {title || description ? (
      <legend>
        {title ? <span>{title}</span> : null}
        {description ? <small>{description}</small> : null}
      </legend>
    ) : null}
    <div className="mis-filter-bar-fields">{children}</div>
  </fieldset>
);

export const SectionCard = ({
  title,
  subtitle,
  actions,
  className,
  children,
  ...props
}) => (
  <section className={classes("mis-section-card", className)} {...props}>
    {title || subtitle || actions ? (
      <header className="mis-section-card-header">
        <div>
          {title ? <h2>{title}</h2> : null}
          {subtitle ? <p>{subtitle}</p> : null}
        </div>
        {actions ? <div className="mis-section-card-actions">{actions}</div> : null}
      </header>
    ) : null}
    <div className="mis-section-card-body">{children}</div>
  </section>
);

export const StatusBadge = ({ tone = "neutral", className, children }) => (
  <span className={classes("mis-status-badge", `is-${tone}`, className)}>
    <span className="mis-status-dot" aria-hidden="true" />
    {children}
  </span>
);

export const EmptyState = ({
  title,
  description,
  action,
  tone = "neutral",
  role = "status",
}) => (
  <div className={classes("mis-state", `is-${tone}`)} role={role}>
    <span className="mis-state-icon" aria-hidden="true">
      {tone === "error" ? "!" : "–"}
    </span>
    <strong>{title}</strong>
    {description ? <p>{description}</p> : null}
    {action ? <div className="mis-state-action">{action}</div> : null}
  </div>
);

export const LoadingState = ({ label = "در حال بارگیری…" }) => (
  <div className="mis-loading-state" role="status" aria-live="polite">
    <span className="mis-loading-spinner" aria-hidden="true" />
    <span>{label}</span>
  </div>
);

export const ActionGroup = ({ className, children, ...props }) => (
  <div className={classes("mis-action-group", className)} {...props}>
    {children}
  </div>
);
